// English locale
import ucExtra from './uc-extra-en.js'

export default {
  ...ucExtra,
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    save: 'Save',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    loading: 'Loading...',
    noData: 'No Data',
    operation: 'Operation',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    actions: 'Actions',
    success: 'Success',
    fail: 'Failed',
    warning: 'Warning',
    error: 'Error',
    tips: 'Tips',
    pleaseSelect: 'Please Select',
    pleaseInput: 'Please Input',
    normal: 'Normal',
    disabled: 'Disabled',
    pleaseLoginFirst: 'Please log in first'
  },

  login: {
    title: 'Login',
    welcome: 'Welcome',
    platformName: 'Shenzhen Copyright Public Service Platform',
    tab: {
      personal: 'Personal',
      enterprise: 'Enterprise'
    },
    personalLogin: 'Personal Login',
    enterpriseLogin: 'Enterprise Login',
    username: 'Username',
    password: 'Password',
    phone: 'Phone',
    verifyCode: 'Verify Code',
    getVerifyCode: 'Get Code',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password',
    loginButton: 'Login',
    register: 'Register',
    logout: 'Log Out',
    submit: 'Login',
    placeholder: {
      phone: 'Enter phone number',
      smsCode: 'Enter verification code',
      enterpriseAccount: 'Enter enterprise account',
      password: 'Enter password'
    },
    sms: {
      getCode: 'Get Code',
      retryAfter: 'Retry in {n}s',
      cantReceive: "Didn't receive code?",
      cantReceiveQ: "Didn't receive code?"
    },
    agree: {
      prefix: 'By checking, you agree to',
      privacy: 'Privacy Policy',
      and: 'and',
      register: 'Registration Agreement'
    },
    personal: {
      wechatScan: 'WeChat Scan',
      phoneLogin: 'Phone Login',
      qrLoading: 'Loading QR code...',
      reload: 'Reload',
      altQrcode: 'WeChat login QR code',
      scanSuccess: 'Scan login successful',
      qrExpired: 'QR code expired',
      clickRefresh: 'Tap to refresh',
      agreeFirstHint: 'Please agree to the privacy policy and registration agreement first',
      loginQrLabel: 'Login QR code'
    },
    enterprise: {
      adminPhone: 'Admin Phone Login',
      accountLogin: 'Enterprise Account',
      rememberMe: 'Remember Me',
      forgotPassword: 'Forgot password?'
    },
    bindPhone: {
      title: 'Bind Phone',
      submit: 'Bind'
    },
    validation: {
      phoneRequired: 'Please enter phone number',
      phoneInvalid: 'Please enter a valid phone number',
      smsRequired: 'Please enter verification code',
      smsLen: 'Code must be 6 digits',
      accountRequired: 'Please enter enterprise account',
      passwordRequired: 'Please enter password',
      passwordMin: 'Password must be at least 6 characters'
    },
    toast: {
      agreeFirstCheckbox: 'Please agree to the privacy policy and registration agreement first',
      qrFailed: 'Failed to get QR code, please retry',
      agreeFirst: 'Please agree to the privacy policy and registration agreement first',
      bindSuccess: 'Phone bound successfully',
      smsNotReceived: 'If you did not receive the code, check the phone number or try again later',
      formRefMissing: 'Form reference missing, please refresh and retry',
      smsSent: 'Verification code sent',
      bindPhoneFirst: 'Please bind your phone first',
      loginSuccess: 'Login successful'
    },
    alertTip: 'Notice',
    forgot: {
      title: 'Reset Password',
      labelAccount: 'Entity Account',
      placeholderAccount: 'Enter entity account',
      labelContactPhone: 'Contact Phone',
      placeholderContactPhone: 'Enter contact phone',
      labelSmsCode: 'Verification Code',
      placeholderSmsCode: 'Enter verification code',
      tip: 'After submission, a new password will be emailed to the entity contact. Please check and keep it safe.',
      submit: 'Confirm',
      smsSend: 'Send Code',
      smsRetryAfter: 'Retry in {n}s',
      validation: {
        phoneRequired: 'Please enter contact phone',
        phoneInvalid: 'Please enter a valid contact phone',
        accountRequired: 'Please enter entity account',
        smsRequired: 'Please enter verification code',
        smsLen: 'Code must be 6 digits'
      },
      toast: {
        smsSent: 'Verification code sent',
        success: 'Password reset successful. New password sent to the contact email'
      }
    },
    privacyPageTitle: 'Shenzhen Copyright Public Service Platform Privacy Policy',
    registerPageTitle: 'Shenzhen Copyright Public Service Platform Registration Agreement'
  },

  userCenter: {
    title: 'User Center',
    account: 'Account',
    message: 'Messages',
    approval: 'Approvals',
    identity: 'Identity Verification',
    admin: 'Enterprise Admin',
    lastLoginTime: 'Last login: ',
    associationMember: 'Association Member',
    avatarAlt: 'User avatar',
    changeAvatar: 'Change avatar',
    nickname: 'Nickname: ',
    nicknamePlaceholder: 'Enter nickname',
    save: 'Save',
    cancel: 'Cancel',
    realName: 'Real name: ',
    enterpriseName: 'Enterprise: ',
    channelName: 'Channel: ',
    organizationName: 'Organization: ',
    registerTime: 'Registered: ',
    channelRelation: 'Belonging {type}: {name}',
    channelType: 'channel',
    organizationType: 'organization',
    tabs: {
      account: 'Account',
      rights: 'My Benefits',
      myRecord: 'My Filings',
      order: 'My Orders',
      invoice: 'My Invoices',
      myConsultation: 'My Consultations',
      activity: 'My Activities',
      collection: 'My Favorites',
      message: 'Messages'
    },
    accountMenu: {
      personalAuth: 'Personal Verification',
      enterpriseAuth: 'Enterprise Verification',
      assessment: 'Enterprise Assessment',
      management: 'Enterprise Admin',
      resetPassword: 'Reset Password',
      myApproval: 'My Authorizations'
    },
    rightsMenu: {
      freeRights: 'New User Free Benefits',
      platformVip: 'Platform VIP Package'
    },
    verifyStatus: {
      unverified: 'Unverified',
      verifying: 'Verifying',
      verified: 'Verified',
      rejected: 'Rejected'
    },
    btn: {
      createEnterprise: 'Verify New Enterprise +',
      exitAdmin: 'Remove Admin Role',
      cancelChannelProxy: 'Cancel Channel Agency',
      exitChannel: 'Leave Channel',
      exitInstitution: 'Leave Organization',
      joinChannel: 'Join Channel',
      copyrightPublicAction: 'Copyright Public Welfare'
    },
    msg: {
      underDevelopment: 'Coming soon',
      completePersonalAuthFirst: 'Please complete personal verification first',
      avatarImageOnly: 'Only image files are allowed!',
      avatarSizeLimit: 'Image size cannot exceed 2MB!',
      uploading: 'Uploading...',
      avatarUploadSuccess: 'Avatar uploaded',
      avatarUploadFail: 'Avatar upload failed',
      avatarUploadFailRetry: 'Avatar upload failed, please retry',
      nicknameRequired: 'Nickname cannot be empty',
      nicknameSaveSuccess: 'Nickname saved',
      saveFail: 'Save failed',
      saveFailRetry: 'Save failed, please retry',
      exitChannelSuccess: 'Left channel successfully',
      cancelChannelProxySuccess: 'Channel agency cancelled',
      exitInstitutionSuccess: 'Left organization successfully',
      getEnterpriseIdFail: 'Failed to get enterprise ID, please retry'
    },
    confirm: {
      title: 'Notice',
      ok: 'OK',
      exitAdmin: 'Remove your admin role in {enterpriseName}?',
      exitChannel: 'Leave this channel?',
      cancelChannelProxy: 'Cancel channel agency?',
      exitInstitution: 'Leave this organization?'
    }
  },

  freeRights: {
    bannerAlt: 'Complete identity verification to use core features for free forever',
    goAuth: 'Verify Now',
    authTips: 'Verification takes 1–2 minutes. Start your copyright journey now',
    benefits: {
      ipDataInquiry: {
        title: 'IP Data Query',
        bullet1: 'Free query of your enterprise IP assets (enterprise accounts only)'
      },
      workRegistration: {
        title: 'Work Filing Management',
        bullet1: 'Free cloud storage for filed works',
        bullet2: 'Free personal or enterprise work library'
      },
      educationTraining: {
        title: 'Copyright Education',
        bullet1: 'Free basic copyright courses',
        bullet2: 'Free contract templates and learning materials',
        bullet3: 'Free copyright news and global updates'
      }
    }
  },

  copyrightPublicAction: {
    dialogTitle: 'Copyright Public Welfare',
    intro: 'This platform offers free copyright public-welfare benefits for the following four identities',
    authHintPrefix: 'Please complete identity verification before applying. Go to',
    authLink: 'Identity Verification »',
    identity: {
      student: 'Student',
      studentDesc: 'Enrolled students for study or research',
      school: 'School',
      schoolDesc: 'Schools and educational institutions',
      commonweal: 'Nonprofit',
      commonwealDesc: 'Non-profit social welfare organizations',
      association: 'Copyright Industry Association',
      associationDesc: 'Copyright-related industry associations and groups',
      fallback: 'this identity'
    },
    time: {
      approvedAt: 'Approved at:',
      expiresAt: 'Expires at:',
      appliedAt: 'Applied at:',
      rejectedAt: 'Rejected at:'
    },
    dateTimePattern: '{y}-{m}-{d} {hh}:{mm}:{ss}',
    emptyDash: '—',
    status: {
      rejected: 'Rejected',
      unknown: 'Unknown',
      approved: 'Approved',
      auditStatus: 'Status: ',
      applyTime: 'Applied: ',
      expireTime: 'Expires: ',
      rejectTime: 'Rejected: ',
      remark: 'Remark: '
    },
    btn: {
      apply: 'Apply',
      reapply: 'Reapply',
      viewDetail: 'View Application',
      prev: 'Previous',
      submit: 'Submit',
      close: 'Close'
    },
    msg: {
      cannotSwitchType: 'You already have a public-welfare application and cannot switch type',
      notOpenYet: 'Not available yet. Stay tuned!',
      identityNotSupported: 'Current identity cannot apply for {identity} benefits',
      completeAuthFirst: 'Please complete identity verification first!',
      resubmitSuccess: 'Resubmitted successfully',
      submitSuccess: 'Application submitted'
    },
    loading: {
      submitting: 'Submitting...'
    },
    enterprise: {
      title: {
        school: 'School Verification',
        commonweal: 'Nonprofit Verification',
        association: 'Association Verification',
        fallback: 'Enterprise Verification'
      },
      nameLabel: {
        school: 'School Name',
        commonweal: 'Organization Name',
        association: 'Association Name',
        fallback: 'Enterprise Name'
      },
      creditCode: 'Unified Social Credit Code',
      usageScenario: 'Public-welfare Use Case',
      usageScenarioPlaceholder: 'Describe how your organization will use the public-welfare benefits',
      ruleUsageScenario: 'Please fill in the use case'
    },
    student: {
      dialogTitle: 'Student Verification',
      bannerAlt: 'Student application',
      warning: 'Note: Only enrolled students of schools that have joined the {highlight} program can apply',
      warningHighlight: 'Youth Copyright Campus Escort',
      name: 'Name',
      idCard: 'ID Card Number',
      uploadReport: 'Upload CHSI Verification Report',
      viewReport: 'View Report',
      schoolName: 'School Name',
      major: 'Major',
      enrollmentTime: 'Enrollment Date',
      graduationTime: 'Expected Graduation',
      placeholder: 'Please enter',
      rule: {
        report: 'Please upload the CHSI verification report',
        schoolName: 'Please enter school name',
        major: 'Please enter major',
        enrollmentTime: 'Please select enrollment date',
        graduationTime: 'Please select expected graduation date'
      }
    },
    upload: {
      hintLine1: 'Upload the Online Student Status Verification Report',
      hintLine2: 'PDF only, max 5MB per file',
      uploadedPrefix: 'Uploaded: ',
      goChsi: 'Download from CHSI »',
      pdfOnly: 'Only PDF files are supported',
      sizeLimit: 'File size cannot exceed {maxSize}MB',
      loading: 'Recognizing...',
      success: 'Uploaded and recognized',
      noFileUrl: 'Recognition finished but file URL is missing, please retry'
    }
  },

  message: {
    title: 'Messages',
    unread: 'Unread',
    read: 'Read',
    starred: 'Starred',
    all: 'All',
    system: 'System',
    business: 'Business',
    activity: 'Activity',
    noMessage: 'No messages',
    noMessageDetail: 'No message details',
    markAsRead: 'Mark as read',
    markAsUnread: 'Mark as unread',
    star: 'Star',
    unstar: 'Unstar',
    delete: 'Delete message',
    time: 'Time',
    sender: 'Sender',
    altIcon: 'Messages',
    unreadTitle: 'Unread Messages',
    allMessages: 'All Messages'
  },

  approval: {
    title: 'My Approvals',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    applicant: 'Applicant',
    approver: 'Approver',
    businessType: 'Business Type',
    approvalStatus: 'Status',
    remark: 'Remark',
    approve: 'Approve',
    reject: 'Reject',
    approvalTime: 'Approval Time',
    sendApproval: 'Send Approval',
    approvalResult: 'Result'
  },

  ipMgmt: {
    title: 'IP Management',
    subtitle: 'Enterprise-grade lifecycle security for IP assets, helping unlock the value of intellectual property.',
    goManage: 'Go to IP Management',
    regionDomestic: 'Domestic Statistics',
    regionInternational: 'International Statistics',
    startManage: 'Start Management',
    expiryRemind: 'Expiry Reminders',
    dataUpdate: 'IP Data Update',
    reportDownload: 'Download IP Report',
    reportExample: 'Sample Report',
    tabOverview: '{name} Overview',
    tabList: '{name} List',
    tabCert: '{name} Certificates',
    overviewTip: 'Import IP certificates to unlock multi-dimensional date charts.',
    asset: {
      all: 'All IP',
      ip: 'Intellectual Property',
      digitalFiling: 'Digital Filing',
      workCopyright: 'Work Copyright',
      softwareCopyright: 'Software Copyright',
      trademark: 'Trademark',
      patent: 'Patent'
    },
    switchedTo: 'Switched to: {name}',
    developing: 'This feature is under development...',
    updateConfirmTitle: 'Confirm Update',
    updateConfirmHtml:
      'Sync and update <strong>work copyright, software copyright, trademark, and patent</strong> lists for the current entity?' +
      '<br/><span style="color: #f56c6c;">(Results will sync into IP Management. Records not in the query results will be removed!)</span>',
    updateSuccess: 'IP data updated',
    updateFail: 'Update failed',
    syncing: 'Syncing, please wait...',
    startDialog: {
      title: 'Import data to start digital IP asset management',
      guide: 'Step-by-step guide',
      queryTitle: 'One-click import from IP query',
      queryAlt: 'One-click import from IP query',
      goQuery: 'Go Query',
      queryFooter: 'Recommended for enterprise users',
      uploadTitle: 'Import via spreadsheet',
      uploadAlt: 'Import via spreadsheet',
      goImport: 'Go Import',
      uploadFooter: 'Available for enterprise and personal users',
      close: 'Close'
    },
    overview: {
      stats: 'IP Statistics',
      analysis: 'IP Analysis',
      share: 'IP Share',
      structure: 'IP Structure',
      exportPng: 'Export as PNG',
      to: 'to',
      allTime: 'All time',
      byYear: 'By year',
      byQuarter: 'By quarter',
      byMonth: 'By month',
      selectYear: 'Select year',
      piece: 'pcs',
      total: 'Total',
      quantity: 'IP Quantity',
      lastMonth: 'Last month',
      lastHalfYear: 'Last 6 months',
      lastYear: 'Last year',
      sum: 'Total',
      currentCount: 'Current',
      yearLabel: '{n}',
      monthLabel: 'M{n}',
      q1: 'Q1',
      q2: 'Q2',
      q3: 'Q3',
      q4: 'Q4',
      exportConfirm: 'Export "{title}" as a PNG image?',
      exportConfirmTitle: 'Confirm Export',
      export: 'Export',
      chartNotReady: 'Chart is not ready yet. Please try again later.',
      downloadSuccess: 'Image downloaded',
      exportFail: 'Export failed',
      digitalStats: 'Digital Filing Statistics',
      digitalAnalysis: 'Digital Filing Analysis',
      digitalShare: 'Digital Filing Share',
      typeStats: '{name} Statistics',
      typeAnalysis: '{name} Analysis',
      typeShare: '{name} Share',
      originalWork: 'Original Works',
      productDesign: 'Product Design Deposit',
      originalFiling: 'Original Digital Filing',
      productFiling: 'Product Release Deposit',
      filingCount: 'Filing Count',
      originalShare: 'Original Works Share',
      productShare: 'Product Design Share',
      analysisOf: 'Analysis: {date}'
    },
    list: {
      addData: 'Add',
      importData: 'Import',
      exportData: 'Export',
      linkAllCerts: 'Link All Certificates',
      viewCert: 'View Certificate',
      bindCert: 'Bind Certificate',
      unbindCert: 'Unbind Certificate',
      goUploadCert: 'Go to Certificate Management to upload',
      certCover: 'Certificate cover (click to preview)',
      noCertCover: 'No certificate cover',
      certNo: 'Certificate No.',
      certType: 'Certificate Type',
      bound: 'Bound',
      unbound: 'Unbound',
      bindCertTitle: 'Bind Certificate',
      unbindCertTitle: 'Unbind Certificate',
      confirmBind: 'Confirm Bind',
      confirmUnbind: 'Confirm Unbind',
      loadingCert: 'Looking up certificate…',
      loadingBoundCert: 'Loading bound certificate…',
      exportConfirm: 'Export {total} records under the current filters?',
      exportConfirmTitle: 'Confirm Export',
      exporting: 'Exporting, please wait…',
      noExportData: 'No data to export',
      deleteConfirmTitle: 'Confirm Delete',
      deleteConfirm: 'Delete record "{title}"?',
      deleting: 'Deleting...',
      openingCert: 'Opening certificate…',
      batchLinkTitle: 'Link Certificates to IP Records',
      batchLinkDesc: 'Linking certificates to IP data management...',
      batchLinkConfirmTitle: 'Confirm Link',
      batchLinkConfirmOk: 'Confirm',
      batchLinkProgress: 'Linking progress',
      batchLinkNoData: 'No records need linking.',
      batchLinkSuccess: 'Linked successfully: {n}',
      batchLinkFail: 'Failed to link: {n}',
      batchLinkFailed: 'Link failed',
      batchLinkConfirmMsg:
        'All unbound {name} list records under the current account will be matched by registration number to unlinked "{name}" certificates. Records with empty registration numbers, no match, or already linked certificates will be skipped. Continue?',
      typeFallback: 'this IP type',
      thisRecord: 'this record',
      fields: {
        regNo: 'Registration No.',
        workName: 'Work Title',
        workType: 'Work Category',
        author: 'Author',
        completeDate: 'Completion Date',
        regDate: 'Registration Date',
        remark: 'Remarks',
        bindCertFlag: 'Certificate Bound',
        softwareName: 'Software Name',
        version: 'Version',
        rightHolder: 'Copyright Owner',
        tmRegNo: 'Registration No.',
        tmName: 'Trademark Name',
        tmPic: 'Trademark Image',
        applicant: 'Applicant',
        applyDate: 'Application Date',
        tmRegDate: 'Registration Date',
        expireDate: 'Expiry Date',
        tmClass: 'Trademark Class',
        goodsServices: 'Goods & Services',
        patentNo: 'Patent No.',
        patentName: 'Patent Title',
        patentType: 'Patent Type',
        inventor: 'Inventor',
        grantDate: 'Grant Date',
        status: 'Status',
        filingNo: 'Filing No.',
        filingType: 'Filing Type',
        digitalFilingNo: 'Digital Filing No.',
        workCategory: 'Work Category',
        serialNo: 'No.'
      },
      ph: {
        regNo: 'Enter registration number',
        workName: 'Enter work title',
        workType: 'Enter work category',
        selectWorkType: 'Select work category',
        author: 'Enter author',
        date: 'Select date',
        remark: 'Enter remarks',
        softwareName: 'Enter software name',
        version: 'Enter version',
        rightHolder: 'Enter copyright owner',
        tmRegNo: 'Enter registration number',
        tmName: 'Enter trademark name',
        applicant: 'Enter applicant',
        selectTmClass: 'Select trademark class',
        goodsServices: 'Enter goods & services',
        imageUrl: 'Image URL (required)',
        patentNo: 'Enter patent number',
        patentName: 'Enter patent title',
        selectPatentType: 'Select patent type',
        inventor: 'Enter inventor',
        statusOptional: 'Status (optional)',
        all: 'All',
        selectRegDate: 'Select registration date'
      },
      importTitle: {
        work: 'Import Work Copyright',
        software: 'Import Software Copyright',
        trademark: 'Import Trademark',
        patent: 'Import Patent'
      },
      importTemplate: {
        work: 'work_copyright_import_template.xlsx',
        software: 'software_copyright_import_template.xlsx',
        trademark: 'trademark_import_template.xlsx',
        patent: 'patent_import_template.xlsx'
      },
      formTitle: {
        addWork: 'Add Work Copyright',
        editWork: 'Edit Work Copyright',
        addSoftware: 'Add Software Copyright',
        editSoftware: 'Edit Software Copyright',
        addTrademark: 'Add Trademark',
        editTrademark: 'Edit Trademark',
        addPatent: 'Add Patent',
        editPatent: 'Edit Patent'
      },
      toast: {
        addSuccess: 'Added successfully',
        addFail: 'Failed to add',
        saveSuccess: 'Saved successfully',
        saveFail: 'Failed to save',
        deleteSuccess: 'Deleted successfully',
        unboundCert: 'No certificate bound',
        getCertFail: 'Failed to get certificate info',
        noCertFileUrl: 'This certificate has no file URL',
        missingIdSave: 'Cannot save: missing record ID',
        missingIdEdit: 'Cannot edit: missing record ID',
        missingIdBind: 'Cannot bind: missing record ID',
        missingIdUnbind: 'Cannot unbind: missing record ID',
        missingIdDelete: 'Cannot delete: missing record ID',
        certNotFound: 'No matching certificate found for the registration number and type',
        certNotFoundBind: 'No matching certificate found. Please upload it to the certificate library first',
        foundUnlinkedCert: 'Found unbound certificate: {name}',
        noName: '(unnamed)',
        loadedBoundCert: 'Loaded bound certificate: {name}',
        loadCertFail: 'Failed to load certificate info',
        certTypeMismatch: 'Bound certificate type does not match this list. Unbind from the matching list.',
        emptyRegNo: 'Registration number is empty; cannot bind certificate',
        missingCertType: 'Certificate type is missing; cannot bind',
        waitCertLoad: 'Please wait until certificate info is loaded',
        bindSuccess: 'Bound successfully',
        bindFail: 'Failed to bind',
        unbindSuccess: 'Unbound successfully',
        unbindFail: 'Failed to unbind',
        notBoundWork: 'This work has no bound certificate',
        missingWorkRecord: 'Cannot bind: missing work record',
        missingUnbindRecord: 'Cannot unbind: missing work record',
        uploadImage: 'Upload image',
        uploading: 'Uploading…',
        orFillImageUrl: 'Or enter image URL below (filled automatically after upload)',
        classN: 'Class {n}',
        view: 'View',
        emptyFilingNo: 'Filing number is empty; cannot view',
        certNotFoundShort: 'Certificate not found',
        needTmPic: 'Please upload or enter trademark image'
      }
    },
    cert: {
      searchPlaceholder: 'Enter full certificate name or number',
      filingSearchPlaceholder: 'Enter work name or digital filing number',
      noCertFile: 'No certificate file',
      pdfThumbTitle: 'Certificate PDF thumbnail',
      upload: 'Upload Certificate',
      uploadTitle: 'Upload Certificate ({type})',
      uploadDomestic: 'Upload Mainland China Certificate',
      uploadInternational: 'Upload International Certificate',
      dropHint: 'Click or drag to upload certificate',
      fileTip: 'JPG, PNG, and PDF supported; max 5MB per file',
      uploadCount: 'Files to upload: ',
      uploadProgress: 'Upload progress',
      confirmUpload: 'Confirm Upload',
      preview: 'Preview',
      download: 'Download',
      editInfo: 'Edit Certificate',
      editAria: 'Edit certificate info',
      selectAria: 'Select certificate',
      unselectAria: 'Deselect',
      previewAlt: 'Certificate preview',
      coverAlt: 'Certificate cover',
      noCover: 'No cover',
      certName: 'Certificate Name',
      certNo: 'Certificate No.',
      certType: 'Certificate Type',
      placeholderCertName: 'Enter certificate name',
      placeholderCertNo: 'Enter certificate number',
      placeholderCertType: 'Select certificate type',
      regDate: 'Registration Date',
      expireDate: 'Expiry Date',
      placeholderRegDate: 'Select registration date',
      placeholderExpireDate: 'Select expiry date',
      filterAll: 'All',
      filterLinked: 'Linked',
      filterUnlinked: 'Unlinked',
      onlyUnlinkedEdit: 'Only unlinked certificates can be edited',
      onlyUnlinkedDelete: 'Only unlinked certificates can be deleted. Deselect linked ones and try again.',
      selectToDelete: 'Please select certificates to delete',
      deleteConfirm: 'Delete {n} selected unlinked certificate(s)? This cannot be undone.',
      deleteConfirmTitle: 'Confirm Delete',
      confirmDelete: 'Delete',
      deleting: 'Deleting...',
      deleteSuccess: 'Deleted successfully',
      editSuccess: 'Updated successfully',
      noPreviewCover: 'No certificate cover to preview',
      noPreviewFile: 'No certificate file to preview',
      noDownloadFile: 'No certificate file to download',
      downloadConfirm: 'Download this certificate file?',
      downloadConfirmTitle: 'Confirm Download',
      confirmDownload: 'Download',
      unsupportedFormat: 'Unsupported file format: {name}',
      fileTooLarge: 'File exceeds 5MB: {name}',
      addFilesFirst: 'Please add certificate files first',
      uploadDone: 'Upload complete',
      ruleCertName: 'Please enter certificate name',
      ruleCertNo: 'Please enter certificate number',
      ruleCertType: 'Please select certificate type',
      statusLinked: 'Linked',
      statusUnlinked: 'Unlinked'
    }
  },

  workbench: {
    title: 'Workbench',
    subtitle: 'Manage your users and business',
    role: {
      channel: 'Channel',
      organization: 'Organization',
      salesman: 'Salesman'
    },
    updateChannelCode: 'Update Channel Code',
    channelCodeDialog: {
      code: 'Channel Code',
      expireTime: 'Expiry Time',
      expireTip: 'Set when the channel code expires',
      placeholderExpire: 'Select expiry time',
      ruleCode: 'Please enter channel code',
      ruleCodeLen: 'Channel code must be 1 to 50 characters',
      ruleExpire: 'Please select expiry time',
      dayN: '{n} day(s)',
      loadFail: 'Failed to load channel code. You can enter it manually.',
      updateSuccess: 'Channel code updated',
      updateFail: 'Failed to update channel code',
      updateFailRetry: 'Failed to update channel code. Please try again later.'
    },
    unbindSalesman: 'Unbind Salesman Identity',
    unbindConfirmTitle: 'Confirm Unbind',
    unbindConfirmMessage: 'Unbind salesman identity? You will lose salesman-related features.',
    unbindConfirmOk: 'Unbind',
    unbindSuccess: 'Unbound successfully!',
    disabledTitle: 'Workbench is unavailable for this account',
    disabledDesc: 'Your salesman account cannot use workbench features. Contact your organization admin if needed.',
    tabs: {
      subChannel: 'Sub-channel Management',
      user: 'User Management',
      salesman: 'Salesman Management',
      dataStats: 'Data Statistics'
    },
    all: 'All',
    dataStats: {
      byYear: 'By year',
      byQuarter: 'By quarter',
      byMonth: 'By month',
      selectYear: 'Select year',
      yearFormat: 'YYYY',
      subChannelStats: 'Service Sub-channel Stats',
      subChannelStatsTotal: 'Total service sub-channels',
      subChannelAnalysis: 'Service Sub-channel Analysis',
      subChannelBusinessStats: 'Service Sub-channel Business Stats',
      subChannelBusinessStatsTotal: 'Total sub-channel business',
      subChannelBusinessAnalysis: 'Service Sub-channel Business Analysis',
      unverified: 'Unverified',
      personalAuth: 'Personal verified',
      enterpriseAuth: 'Enterprise verified',
      originalFiling: 'Original work filing',
      productDeposit: 'Product release deposit',
      ipQuery: 'IP inquiry',
      infringementMonitor: 'Infringement monitoring',
      evidenceCollection: 'Self-service evidence',
      unitPiece: '',
      unitPerson: '',
      unitEnterprise: '',
      userStats: 'User Statistics',
      userTotal: 'Total users',
      userConversion: 'User Service Conversion',
      userConversionOverall: 'Overall conversion rate: ',
      conversionRate: 'Conversion',
      converted: 'Converted',
      unconverted: 'Not converted',
      userGrowth: 'User Growth Trend',
      personalUser: 'Personal users',
      enterpriseUser: 'Enterprise users',
      businessStats: 'Business Handling Statistics',
      businessTotal: 'Total business volume',
      businessGrowth: 'Business Handling Growth',
      originalDigitalFiling: 'Original digital filing',
      workTypeDistribution: 'Work Type Distribution',
      rankingTitle: 'User Business Ranking (TOP 20)',
      rankingAll: 'Overall',
      rankingSerial: 'No.',
      rankingUserName: 'User name',
      rankingUserType: 'User type',
      rankingTotal: 'Total handled',
      rankingBusinessTypes: 'Business types',
      noData: 'No data',
      q1: 'Q1',
      q2: 'Q2',
      q3: 'Q3',
      q4: 'Q4',
      monthlyNew: 'New this month',
      monthlyNewDetail: 'New this month / {n}',
      monthlyNewLegend: 'New this month {n}',
      handleProductTotal: 'Product release deposits / {n}',
      handleOriginalTotal: 'Original work filings / {n}',
      unitGe: '',
      totalSuffix: ' total',
      statsSuffix: '',
      overview: 'Overview',
      shareRate: 'Share {rate}',
      identityCityAssoc: 'Direct units & municipal artist associations',
      identityCityAssocWrapped: 'Direct units &\nmunicipal artist associations',
      identityDistrictAssoc: 'District artist associations',
      identityArtNewOrg: 'New art organizations',
      identitySupportRegion: 'Paired-support region orgs',
      serviceChannelStats: 'Service Channel Statistics',
      subChannelTotal: 'Total sub-channels',
      countSuffix: ' count',
      businessCountSuffix: ' business count',
      serviceMember: ' service members',
      serviceMemberTotal: ' service members total',
      serviceMemberConversion: 'Copyright digital governance service member conversion',
      memberOverallRate: 'Overall sub-channel member conversion: ',
      serviceMemberGrowth: 'Service Channel Member Growth',
      serviceBusinessGrowth: 'Service Channel Business Growth',
      artistMemberStats: 'Artist Member Statistics',
      memberTotal: 'Total members',
      personalMember: 'Personal members',
      enterpriseMember: 'Enterprise members',
      personalMemberTotal: 'Personal members total',
      enterpriseMemberTotal: 'Enterprise members total',
      memberUnitLabel: '{name} members: {n} {unit}',
      primaryBusinessStats: 'Copyright digital governance business statistics',
      subChannelOriginalCount: 'Sub-channel original work filings',
      subChannelProductCount: 'Sub-channel product release deposits',
      subChannelBusinessTotal: 'Total sub-channel business',
      businessTotalWithName: '{name} business total: {n} {unit}',
      originalFilingCount: '{label}: {n} {unit}',
      productDepositCount: '{label}: {n} {unit}'
    },
    subChannel: {
      creditCode: 'Entity ID Code',
      channelName: 'Sub-channel Name',
      contact: 'Contact',
      contactPhone: 'Phone',
      district: 'District',
      districtFederation: 'District Federation',
      add: 'Add Sub-channel',
      editTitle: 'Edit Sub-channel',
      name: 'Sub-channel Name',
      type: 'Sub-channel Type',
      channelType: 'Channel Type',
      remark: 'Remarks',
      remarkInfo: 'Remarks',
      edit: 'Edit',
      placeholderType: 'Select sub-channel type',
      ruleType: 'Please select sub-channel type',
      missingSubChannelId: 'Missing sub-channel ID',
      saveSuccess: 'Saved successfully',
      delete: 'Delete Sub-channel',
      deleteConfirm: 'Delete sub-channel "{name}"? The enterprise will revert to a normal enterprise, and users under this sub-channel will be dismissed.',
      defaultEnterpriseName: 'this enterprise',
      missingIdEdit: 'Missing enterprise ID; cannot edit',
      missingIdDelete: 'Missing enterprise ID; cannot delete',
      deleteSuccess: 'Deleted successfully',
      importStub: 'Import data clicked',
      dialog: {
        enterpriseQuery: 'Enterprise Search',
        enterpriseQueryDesc: 'Enter an enterprise name to find verified ordinary enterprises, then fill in the details below',
        placeholderEntName: 'Enter enterprise name',
        enterpriseName: 'Enterprise Name',
        placeholderSelectEnterprise: 'Search and select an enterprise first',
        smsCode: 'Verification Code',
        placeholderSmsCode: 'Enter verification code',
        getSmsCode: 'Get Code',
        smsCountdown: 'Resend in {n}s',
        placeholderSubChannelName: 'Enter sub-channel name',
        placeholderChannelType: 'Select channel type',
        placeholderDistrict: 'Select district federation',
        placeholderRemark: 'Enter remarks',
        detailTitle: 'Matched Enterprise',
        creditCode: 'Unified Social Credit Code',
        confirmSelect: 'Confirm Selection',
        selectedOk: 'Enterprise selected',
        needEntName: 'Please enter an enterprise name',
        noMatch: 'No matching enterprise found',
        needSelectEnterprise: 'Select an enterprise first to get the contact phone',
        phoneInvalid: 'Invalid contact phone; cannot send verification code',
        smsSent: 'Verification code sent',
        smsFail: 'Failed to get verification code, please retry',
        needQuerySelect: 'Please search and select an enterprise first',
        needSmsCode: 'Please enter the SMS code for the contact phone',
        addSuccess: 'Added successfully',
        ruleChannelType: 'Channel type is required',
        ruleDistrict: 'Please select a district federation',
        ruleEnterprise: 'Enterprise is required',
        ruleSubChannelName: 'Please enter a sub-channel name',
        ruleSmsCode: 'Please enter the verification code'
      }
    },
    userMgmt: {
      userTypeAria: 'User type',
      personal: 'Personal Users',
      enterprise: 'Enterprise Users',
      realName: 'Real Name',
      phone: 'Mobile',
      email: 'Email',
      idNumber: 'ID Number',
      enterpriseName: 'Enterprise Name',
      creditCode: 'Entity ID Code',
      contactPhone: 'Contact Phone',
      agentStatus: 'Agency Status',
      unauthorized: 'Unauthorized',
      authorized: 'Authorized',
      invitePersonal: 'Invite Personal User',
      inviteEnterprise: 'Invite Enterprise User',
      nickname: 'Nickname',
      contact: 'Contact',
      contactEmail: 'Contact Email',
      authorizedAgent: 'Authorized Agent',
      lastUpdateTime: 'Last Updated',
      inviteAgent: 'Invite Agent',
      cancelAuth: 'Revoke Authorization',
      remove: 'Remove',
      startInvite: 'Send Invite',
      loadFail: 'Failed to load user list',
      inviteSuccess: 'Invitation sent',
      inviteProxyTitle: 'Invite as Agent',
      inviteProxyConfirm: 'Invite {type} "{name}" as an authorized agent?',
      inviteProxySent: 'Agent authorization request sent',
      cancelAuthTitle: 'Revoke Authorization',
      cancelAuthConfirm: 'Revoke authorized-agent status for {type} "{name}"?',
      removeConfirm: 'Remove {type} "{name}"?',
      removeSuccess: 'Removed successfully',
      removeFail: 'Remove failed',
      fallbackUser: 'user',
      fallbackEnterprise: 'enterprise',
      unknown: 'Unknown'
    },
    salesman: 'Salesman Management',
    user: 'User Management',
    addSalesman: 'Add Salesman',
    salesmanName: 'Name',
    idCard: 'ID Card',
    phone: 'Phone',
    inviteTime: 'Invite Time',
    removeSalesman: 'Remove Salesman',
    confirmRemoveSalesman: 'Remove salesman "{name}"?',
    removeSuccess: 'Deleted successfully',
    removeFail: 'Delete failed, please retry',
    inviteSuccess: 'Approval request sent, waiting for confirmation',
    inviteFail: 'Failed to send approval request, please retry',
    serialNumber: 'No.',
    loadListFail: 'Failed to load salesman list',
    cannotGetEnterpriseInfo: 'Unable to get current enterprise info',
    inviteSalesmanRemark: 'Invite {name} as salesman',
    placeholderSalesmanName: 'Enter salesman name',
    placeholderPhone: 'Enter phone number',
    statusChangeSuccess: 'Status updated',
    statusChangeFail: 'Failed to update status, please retry',
    enable: 'Enable',
    disable: 'Disable',
    confirmStatusChange: 'Confirm to {status} salesman "{name}"?',
    assignCustomer: {
      title: 'Assign Customers',
      titleWithName: 'Assign Customers - {name}',
      currentAssigned: 'Currently Assigned',
      currentAssignedDesc: 'View customers assigned to this salesman; you can remove assignments',
      goAssign: 'Assign Users',
      goAssignDesc: 'Select customers and assign them to this salesman',
      clientType: 'Customer Type',
      personalClient: 'Individual',
      enterpriseClient: 'Enterprise',
      emptyAssigned: 'No assigned customers',
      emptyAssignable: 'No customers available to assign; confirm authorized customers exist',
      unassign: 'Remove Assignment',
      confirmUnassign: 'Cancel the assignment between this customer and the current salesman?',
      unassignSuccess: 'Assignment removed',
      unassignFail: 'Failed to remove assignment',
      selectAtLeastOne: 'Please select at least one customer',
      salesmanIncomplete: 'Salesman information is incomplete',
      cannotAssign: 'Salesman information is incomplete; cannot assign customers',
      assignSuccess: 'Assigned successfully',
      assignFail: 'Assignment failed',
      confirmAssign: 'Confirm Assign ({n} selected)',
      loadFail: 'Failed to load customer list'
    }
  },

  enterpriseAdmin: {
    title: 'Enterprise Admin',
    addAdmin: 'Invite Admin',
    refresh: 'Refresh',
    adminName: 'Admin Name',
    adminPhone: 'Admin Phone',
    adminStatus: 'Status',
    adminType: 'Type',
    removeAdmin: 'Remove Admin',
    confirmRemoveAdmin: 'Remove admin "{name}"?',
    removeSuccess: 'Removed successfully',
    removeFail: 'Remove failed, please retry',
    statusChangeSuccess: 'Status updated',
    statusChangeFail: 'Failed to update status, please retry'
  },

  inviteDialog: {
    title: 'Invite Personal User',
    inviteeIdCard: 'Invitee ID Card',
    inviteePhone: 'Invitee Phone',
    inviteeInfo: 'Invitee details:',
    refreshQuery: 'Refresh',
    queryAccount: 'Query invitee account',
    nickname: 'Nickname',
    realName: 'Real Name',
    idCard: 'ID Card',
    phone: 'Phone',
    verifiedStatus: 'Verification Status',
    isAdmin: 'Is Admin',
    isSalesman: 'Is Organization Salesman',
    verified: 'Verified',
    unverified: 'Unverified',
    verifying: 'Verifying',
    rejected: 'Rejected',
    yes: 'Yes',
    no: 'No',
    sendSmsCode: 'Send Code',
    resendSmsCode: 's to resend',
    verifyCode: 'Invitee SMS Code',
    pleaseInputVerifyCode: 'Enter invitee SMS code',
    confirmInvite: 'Confirm as salesman',
    confirmInviteAdmin: 'Confirm as admin',
    querySuccess: 'Query successful',
    queryFail: 'Failed to query user, please retry',
    notFound: 'No matching user found',
    pleaseFillForm: 'Please complete the form',
    pleaseFillIdCardAndPhone: 'Please fill in ID card and phone first',
    pleaseQueryFirst: 'Please query invitee information first'
  },

  validation: {
    required: 'This field is required',
    idCardFormat: 'Please enter a valid ID card number',
    phoneFormat: 'Please enter a valid phone number',
    emailFormat: 'Please enter a valid email address',
    minLength: 'Length cannot be less than {min} characters',
    maxLength: 'Length cannot exceed {max} characters'
  },

  header: {
    workbench: 'Workbench',
    freeTrial: 'User Benefits',
    ipManagement: 'IP Management',
    certificateReportVerification: 'Certificate Verification',
    navMenu: 'Navigation',
    openNav: 'Open navigation menu',
    closeNav: 'Close navigation menu',
    logoAlt: 'Shenzhen Copyright Public Service Platform',
    langSwitchedZh: 'Switched to Simplified Chinese',
    langSwitchedTw: 'Switched to Traditional Chinese',
    langSwitchedEn: 'Language switched to English'
  },

  footer: {
    officialAccount: 'Shenzhen Copyright Association',
    officialAccountSub: 'WeChat Official Account',
    altOfficialQr: 'Official account QR code',
    contactUs: 'Contact Us',
    softwareRegistration: 'Software Reg.:',
    workRegistration: 'Work Reg.:',
    evidenceSolidification: 'Evidence:',
    membership: 'Membership:',
    email: 'Email:',
    address: 'Address:',
    helpCenter: 'Help Center',
    manual: 'User Manual',
    faq: 'FAQ',
    aboutUs: 'About Us',
    aboutPlatform: 'About Platform',
    officialWebsite: 'Association Website',
    copyrightPrefix: 'Shenzhen Copyright Association Copyright ©',
    copyrightSuffix: 'All Rights Reserved.',
    icp: 'ICP No. 12009572-7',
    privacy: 'Privacy Policy',
    terms: 'Registration Agreement',
    noGuide: 'No platform guide available',
    guideLoadFail: 'Failed to load platform guide'
  },

  userMenu: {
    altAvatar: 'User avatar',
    altPersonal: 'Personal',
    altChannelEnterprise: 'Channel enterprise',
    altOrgEnterprise: 'Organization enterprise',
    altNormalEnterprise: 'Enterprise',
    profile: 'Profile',
    myRights: 'My Benefits',
    enterpriseAdmin: 'Enterprise Admin',
    logout: 'Log Out',
    switchIdentity: 'Switch Identity',
    switchToPersonal: 'Switch to Personal',
    switchToEnterprise: 'Switch to Enterprise',
    confirmSwitchMessage: 'Switch user identity?',
    confirmTip: 'Notice',
    confirmSwitchOk: 'Confirm',
    switching: 'Switching identity...',
    switchSuccess: 'Switched successfully!',
    confirmLogoutMessage: 'Log out?',
    confirmLogoutOk: 'Log Out',
    loggingOut: 'Logging out...',
    loggedOut: 'Logged out',
    logoutFailed: 'Logout failed'
  },

  platformGuide: {
    altIcon: 'Platform Guide',
    title: 'Platform Guide',
    loading: 'Loading…',
    empty: 'None',
    loadFailed: 'Failed to load guide',
    missingId: 'Missing item ID, cannot open details',
    unnamed: 'Untitled',
    column: {
      accountManage: 'Account & Admin',
      selfService: 'Self-Service',
      certVerify: 'Certificate & Report',
      memberCooperate: 'Membership & Partners'
    }
  },

  loginAuth: {
    ariaLabel: 'Login and identity verification notice',
    goLoginPrefix: 'Please go to',
    goLoginLink: '[Login]',
    goLoginSuffix: '.',
    goAuthPrefix: 'Please go to',
    goAuthLink: '[Identity Verification]',
    goAuthSuffix: 'to complete verification.',
    desc: {
      query: {
        loggedOut: 'Please log in and complete identity verification before querying IP assets;',
        unverified: 'Please complete identity verification before querying IP assets;'
      },
      filing: {
        loggedOut: 'Please log in and complete identity verification before digital filing;',
        unverified: 'Please complete identity verification before digital filing;'
      },
      monitoring: {
        loggedOut: 'Please log in and complete identity verification before creating a monitoring task;',
        unverified: 'Please complete identity verification before creating a monitoring task;'
      },
      ipManagement: {
        loggedOut: 'Please log in and complete identity verification before entering IP Management;',
        unverified: 'Please complete identity verification before entering IP Management;'
      },
      contractDownload: {
        loggedOut: 'Please log in and complete identity verification before downloading contract templates;',
        unverified: 'Please complete identity verification before downloading contract templates;'
      },
      reportDownload: {
        loggedOut: 'Please log in and complete identity verification before downloading reports;',
        unverified: 'Please complete identity verification before downloading reports;'
      },
      attachmentDownload: {
        loggedOut: 'Please log in and complete identity verification before downloading attachments;',
        unverified: 'Please complete identity verification before downloading attachments;'
      }
    },
    skipAuth: 'Skip for now',
    skipLogin: 'Skip for now',
    goAuth: 'Verify',
    goLogin: 'Log In',
    loginBeforeAuth: 'Please log in before identity verification'
  },

  selectIdentity: {
    close: 'Close',
    loading: 'Loading...',
    altPersonalAvatar: 'Personal avatar',
    altEnterpriseAvatar: 'Enterprise avatar',
    enterpriseSection: 'Enterprise Identity',
    enterpriseCount: '{count} enterprise identities',
    titleSelectEnterprise: 'Select Enterprise',
    titleSelectUser: 'Select Managed User',
    confirmLogin: 'Confirm Login',
    confirmSwitch: 'Confirm Switch',
    personalUser: 'Personal User',
    toastSelectEnterprise: 'Please select an enterprise',
    toastSelectUser: 'Please select a managed user'
  },

  home: {
    nav: {
      forYou: 'For You',
      copyrightProtection: 'Copyright Protection',
      copyrightService: 'Copyright Services',
      authorizationTrading: 'Licensing',
      education: 'Education',
      globalCopyrightNews: 'Global News',
      industryEvents: 'Events',
      regulations: 'Policies',
      industryDistribution: 'Industry Map',
      serviceOrganizations: 'Service Orgs'
    },
    secondary: {
      originalWorkFiling: 'Original Work Filing',
      productLaunchFiling: 'Product Launch Evidence',
      copyrightPreExamination: 'Copyright Pre-review',
      intellectualPropertyManagement: 'IP Management',
      copyrightRiskMonitoring: 'Risk Monitoring',
      evidenceCollection: 'Self Evidence',
      contractTemplates: 'Contract Templates',
      freeConsultation: 'Free Consultation',
      workCopyrightRegistration: 'Work Copyright Reg.',
      softwareCopyrightRegistration: 'Software Copyright Reg.',
      tsaEvidence: 'TSA Evidence',
      ipDisputeMediation: 'IP Dispute Mediation',
      copyrightAppraisal: 'Copyright Appraisal',
      copyrightCompliance: 'Compliance Guidance',
      copyrightTraining: 'Training Cooperation',
      infringementAppeal: 'Infringement Appeal',
      copyrightSocialOrg: 'Copyright Social Orgs',
      excellentLawFirms: 'Featured Law Firms',
      excellentConsulting: 'Featured Consultancies',
      professionalNews: 'Professional News',
      licensingNews: 'Licensing News',
      frontierReport: 'Frontier Reports',
      deepAnalysis: 'In-depth Analysis',
      findIp: 'Find IP',
      findBrand: 'Find Brand',
      findSupply: 'Find Supply Chain'
    },
    search: {
      label: 'IP Search',
      placeholder: 'Mainland China registered legal entities only',
      workCopyright: 'Work Copyright',
      softwareCopyright: 'Software Copyright',
      trademark: 'Trademark',
      patent: 'Patent',
      all: 'All',
      button: 'Search',
      verifyFirst: 'Please complete identity verification before IP search',
      keywordEmpty: 'Search keyword cannot be empty!',
      selectType: 'Please select at least one IP type!',
      ownEnterpriseOnly: 'You can only search your own enterprise IP',
      enterpriseOnly: 'This feature is for enterprise accounts only. Please use an enterprise account.'
    },
    aria: {
      navPrev: 'Scroll navigation left',
      navNext: 'Scroll navigation right',
      secondaryPrev: 'Scroll secondary menu left',
      secondaryNext: 'Scroll secondary menu right'
    },
    membership: {
      beta: {
        title: 'Shenzhen Municipal IP Public Service Outlet',
        description: 'IP data query, original work filing, asset visualization and more are now fully open. Complete real-name verification to use platform services.',
        button: 'Verify Now'
      },
      title: {
        guest: 'Sign in to learn more',
        unverified: 'Complete identity verification to unlock IP management benefits',
        verified: 'Become a Platform Member and enjoy exclusive benefits',
        platform: 'Upgrade to Platform Member for more benefits',
        plus: 'Upgrade to Plus Member for more benefits',
        international: 'International Member — enjoy the highest benefits'
      },
      description: {
        guest: 'IP services that protect and certify your creative works.',
        unverified: 'IP services that protect and certify your creative works.',
        verified: 'Become a member for worry-free filing and protect your creative works.',
        platform: 'Upgrade to Plus/International Member for more benefits and protect your creative works.',
        plus: 'Upgrade to International Member for more benefits and protect your creative works.',
        international: 'International Member protects your creative works with top-tier benefits.'
      },
      button: {
        guest: 'Try Free',
        unverified: 'Verify Identity',
        verified: 'Join Membership',
        platform: 'Upgrade',
        plus: 'Upgrade',
        international: 'Member Benefits'
      },
      tag: {
        platform: 'Platform Member',
        plus: 'Plus Member',
        international: 'International Member'
      },
      iconAlt: 'Icon'
    },
    ecosystem: {
      title: 'Join Us in Building a Copyright Value Ecosystem',
      itemAlt: 'Ecosystem partner'
    },
    message: {
      title: 'Feedback',
      introPrefix: 'We are',
      associationName: 'Shenzhen Copyright Association',
      introSuffix: '. Feel free to share your experience and feature suggestions.',
      verifyHint: 'Please complete identity verification before leaving a message so we can contact you.',
      placeholder: 'Share product suggestions or copyright issues you have encountered. Our professional team is ready to help...',
      submit: 'Submit',
      toastLoginFirst: 'Please log in before leaving a message',
      toastEmpty: 'Please enter your message',
      toastSuccess: 'Message submitted. Thank you for your feedback!'
    }
  },

  myRecord: {
    filedWorks: 'Filed Works',
    transferredWorks: 'Transferred Works',
    authorizedWorks: 'Authorized Works',
    drafts: 'Drafts',
    filingType: 'Filing Type',
    selectYear: 'Select Year',
    workName: 'Work Title',
    search: 'Search',
    all: 'All',
    image: 'Image',
    audio: 'Audio',
    video: 'Video',
    document: 'Document',
    loading: 'Loading...',
    audioWork: 'Audio Work',
    documentWork: 'Document Work',
    workFile: 'Work File',
    filingTypeOriginal: 'Original Digital Filing',
    filingTypeProduct: 'Product Launch Evidence',
    draftUnavailable: 'Unable to get draft info',
    detail: {
      section: {
        filingInfo: 'Filing Information',
        workDetail: 'Work Details',
        workDesc: 'Work Description',
        certificate: 'Certificates',
        firstPubLink: 'First Publication Link'
      },
      label: {
        workName: 'Work Title: ',
        workType: 'Work Type: ',
        copyrightOwner: 'Copyright Owner: ',
        applyTime: 'Applied: ',
        filingNo: 'Filing No.: ',
        passTime: 'Approved: ',
        filingStatus: 'Status: '
      },
      utcSuffix: ' (UTC+8) ',
      status: {
        reviewing: 'Under Review',
        cancelled: 'Cancelled',
        rejected: 'Rejected',
        passed: 'Approved',
        revoked: 'Revoked',
        transferred: 'Transferred',
        none: 'None'
      },
      btn: {
        goRegistration: 'Go to Work Registration',
        share: 'Share',
        sendEmail: 'Send Certificate Email',
        openInNewWindow: 'Open in New Window',
        viewInNewWindow: 'View in New Window',
        downloadPdf: 'Click to Download PDF',
        openInNewWindowClick: 'Click to Open in New Window'
      },
      mainImageTag: 'Certificate Main Image',
      mainImage: 'Main Image',
      mainFile: 'Main File',
      zoomImage: 'Zoom Image',
      audio: 'Audio',
      video: 'Video',
      document: 'Document',
      workTitle: 'Work “{name}”',
      author: 'Author: ',
      docPreviewFail: 'Failed to load document preview',
      docPreview: 'Document Preview',
      noWorkFile: 'No work file',
      file: 'File',
      certFiling: 'Work Filing Certificate',
      certTimestamp: 'Timestamp',
      certTimestampFull: 'Timestamp Certificate',
      certPreviewFail: 'Failed to load certificate preview',
      noCertificate: 'No certificate',
      snapshot: 'Snapshot',
      noSnapshot: 'No snapshot',
      linkDomain: 'Link Domain',
      none: 'None',
      vipSubtitle: 'Free for Platform, Plus, and International members',
      toast: {
        featureClosed: 'This feature is not available yet',
        noFileUrl: 'File URL not found',
        noImageUrl: 'Image URL not found',
        certPreview: 'Certificate preview failed. Please try again later',
        noCertFile: 'Certificate file not found',
        certDownloadFail: 'Certificate download failed. Please try again later',
        linkCopied: 'Link copied to clipboard',
        copyFail: 'Copy failed',
        needRights: 'Please obtain the benefit before using this feature',
        emailFail: 'Failed to send email. Please try again',
        emailFailAdmin: 'Failed to send email. Please contact the administrator.',
        emailSuccess: 'Email sent successfully!',
        emailFailRetry: 'Failed to send email. Please try again later'
      },
      confirm: {
        sendEmail: 'Send the certificate email?',
        title: 'Confirm',
        ok: 'Confirm',
        cancel: 'Cancel'
      },
      downloadName: {
        filingCert: 'Work-Filing-Certificate.pdf',
        timestampCert: 'Timestamp-Certificate.pdf'
      }
    }
  },

  activityDetail: {
    backToList: 'Back to Activities',
    activityId: 'Activity ID: ',
    registerNow: 'Register Now',
    ended: 'Ended',
    contact: 'Contact: ',
    emptyIntro: 'No activity introduction',
    notFound: 'Activity not found or unavailable',
    loading: 'Loading...',
    toast: {
      endedCannotRegister: 'This activity has ended and cannot be registered',
      contactCopied: 'Contact copied',
      registerSuccess: 'Registration submitted'
    },
    register: {
      title: 'Register for Activity',
      submit: 'Submit',
      placeholder: 'Please enter',
      label: {
        name: 'Name',
        sex: 'Gender',
        position: 'Position',
        unitName: 'Organization',
        phone: 'Mobile',
        email: 'Email',
        busStop: 'Pick-up Point'
      },
      sex: {
        male: 'Male',
        female: 'Female'
      },
      busStop: {
        gaoxinSouth: 'Gaoxin South',
        shenzhenBay: 'Shenzhen Bay Port',
        self: 'Go on your own'
      },
      rule: {
        name: 'Please enter your name',
        sex: 'Please select gender',
        position: 'Please enter your position',
        unitName: 'Please enter organization name',
        phone: 'Please enter mobile number',
        phoneInvalid: 'Please enter a valid mobile number',
        email: 'Please enter email',
        emailInvalid: 'Please enter a valid email',
        busStop: 'Please select a pick-up point'
      }
    }
  },


  // Original work filing / Product launch evidence
  digitalFiling: {
    defaultTitle: 'Original Work Digital Filing',
    defaultSubtitle: 'A fast alternative to the Copyright Bureau Work Registration Certificate. Timestamp and blockchain technologies enable quick rights confirmation for original works.',
    consult: 'Consult / Contact',
    consultPhone: 'Hotline: 0755-86185583',
    contactPerson: 'Contact: Ms. Zou',
    wechatQrAlt: 'WeCom QR code',
    wechatQrConfig: 'Please configure the WeCom QR code',
    wechatQrLabel: 'WeCom QR Code',
    steps: {
      upload: 'Upload Work',
      completeInfo: 'Complete Work Info',
      confirmInfo: 'Confirm Work Info',
      pay: 'Pay Fee',
      submit: 'Submit for Review'
    },
    upload: {
      title: 'Upload Work',
      formatLabel: 'Accepted formats:',
      certExample: 'Certificate Sample',
      workDisplay: 'Work Preview',
      mainImageTag: 'Certificate Cover Image',
      workNamed: 'Work "{name}"',
      author: 'Author: {name}',
      mainImage: 'Main image',
      instructionsOriginal: 'Supports image, Word, PDF, audio, and video. Max 10MB per image (up to 6 images); max 25MB per file.',
      instructionsProduct: 'Product launch evidence currently supports images only. Max 10MB per image, up to 6 images.',
      hintOriginal: 'Supports image, Word, PDF, audio, and video',
      hintProduct: 'Images only, max 10MB each, up to 6'
    },
    form: {
      basicInfo: 'Basic Information',
      workName: 'Work Title',
      applicant: 'Applicant',
      workType: 'Work Type',
      workTypeLink: 'View detailed copyright work type descriptions',
      originality: 'Originality Statement',
      originalityHint: 'Briefly describe the following (recommended 100–200 characters)',
      firstPubLink: 'First Publication Link',
      rightsAcquisition: 'Rights Acquisition',
      rightsCommitment: 'The applicant confirms that the rights were obtained from a legitimate source and that the submitted work does not infringe any third-party copyright or other lawful rights. The applicant bears full legal liability for any disputes arising from false information.',
      cooperativeWork: 'Joint Work',
      addCoAuthor: '+ Add Co-author',
      coAuthorName: 'Co-author Name',
      coAuthorType: 'Co-author Type',
      coAuthorCard: 'ID / Unified Social Credit Code',
      individualAuthor: 'Individual Co-author',
      enterpriseAuthor: 'Enterprise Co-author',
      placeholder: 'Please enter',
      pleaseSelect: 'Please select',
      idCardPlaceholder: 'Enter ID card number',
      creditCodePlaceholder: 'Enter unified social credit code',
      action: 'Actions',
      clear: 'Clear'
    },
    confirm: {
      workName: 'Work Title: ',
      workType: 'Work Type: ',
      applicant: 'Applicant: ',
      acquisitionMethod: 'Acquisition: ',
      scanSign: 'Scan to Sign',
      qrLoading: 'Loading QR code...',
      regenerateSign: 'Regenerate Signature',
      syncSign: 'Sync Signature',
      syncTip: 'After signing on your phone, tap here to sync',
      wechatSignTip: 'Scan with WeChat to complete your personal signature. It will appear on the filing certificate—please write carefully.'
    },
    success: {
      title: 'Submitted Successfully',
      subtitle: 'Your filing has been submitted for review. Results are expected within 1 business day.',
      workInfo: 'Work Information',
      currentAccount: 'Account:',
      businessType: 'Service Type:',
      filingStatus: 'Filing Status:',
      rightsAcquisition: 'Rights Acquisition:',
      workName: 'Work Title:',
      workType: 'Work Type:',
      applicant: 'Applicant:',
      applyTime: 'Applied At:',
      continueFiling: 'Continue Filing',
      goMyRecord: 'Go to My Filings',
      statusReviewing: 'Under Review'
    },
    certExample: {
      basic: 'Basic Certificate',
      international: 'International Certificate',
      timestamp: 'Trusted Timestamp Certificate',
      alt: 'Certificate sample'
    },
    btn: {
      next: 'Next',
      nextPage: 'Next Page',
      prevPage: 'Previous Page',
      back: 'Back',
      certPreview: 'Certificate Preview'
    },
    intlNamePersonal: 'International Name',
    intlNameEnterprise: 'International Organization Name',
    typeOriginal: 'Original Work Filing',
    typeProduct: 'Product Launch Evidence',
    rights: {
      '0': { label: 'Original Ownership', tip: 'Created independently by you/your organization, or jointly by multiple parties.' },
      '2': { label: 'Commissioned Work', tip: 'Obtained under a commissioning agreement.' },
      '3': { label: 'Work Made for Hire', tip: 'Obtained under an employment relationship or official duties.' },
      '1': { label: 'Assignment / Transfer', tip: 'Obtained via transfer, inheritance, merger, or asset allocation.' }
    },
    payment: {
      loadingPrice: 'Fetching latest prices...',
      basic: 'Basic',
      basicDesc: 'Permanent cloud storage with judicial-grade hash verification',
      priceUnit: 'CNY / piece',
      basicVipFree: 'Free for Platform VIP, VIP Plus, and International VIP',
      international: 'International',
      internationalDesc: 'Includes internationally recognized timestamp verification for global e-commerce enforcement',
      internationalVipFree: 'Free for International VIP',
      payable: 'Amount Due',
      yuan: 'CNY',
      payMethod: 'Payment Method',
      wechatPay: 'WeChat Pay',
      cardPay: 'Quota Card',
      cardFreeHint: 'Member free benefit applied; quota card not needed',
      cardRemain: '({count} remaining)',
      noCard: 'No quota card available',
      channel: 'Channel',
      actualPay: 'Amount Payable',
      memberFree: 'Member free benefit',
      channelDefault: 'Channel',
      channelFree: '{name} channel users enjoy free benefits',
      channelDiscount: '{name} channel users enjoy {zhe}% off',
      upgradeBasic: 'Upgrade to Platform/Plus VIP to unlock <span style="color: #F37C0D">unlimited</span> basic filings for the year',
      upgradeIntl: 'Upgrade to International VIP to unlock <span style="color: #F37C0D">unlimited</span> international filings for the year',
      openVip: 'Activate Membership',
      goUpgrade: 'Upgrade',
      confirmSubmit: 'Confirm & Submit',
      payNow: 'Pay Now'
    },
    workUpload: {
      dragHint: 'Drag files here or click to upload',
      setMain: 'Set as Main',
      delete: 'Delete',
      mainBadge: 'Main',
      file: 'File',
      unsupported: 'Unsupported file format',
      imageOnly: 'Only image formats are supported',
      conflictNonImage: 'An audio/video/document file already exists. Remove it before uploading images.',
      maxImages: 'You can upload up to {count} images',
      sizeOver: '{type} must not exceed {size}MB',
      typeImage: 'Image',
      typeFile: 'File',
      uploading: 'Uploading...',
      uploadingDetect: 'Uploading and checking...',
      noUrl: 'Upload failed: file URL missing',
      noQualifiedId: 'Compliance check failed: work ID missing',
      uploadOk: 'Uploaded successfully',
      setMainOk: 'Set as main image',
      deleted: 'Image deleted'
    },
    toast: {
      notOpen: 'Not available yet',
      needSignature: 'Please complete your personal signature first',
      needMainImage: 'Please upload at least one image and set a main image',
      needWorkName: 'Please enter the work title',
      needApplicant: 'Please enter the applicant',
      needWorkType: 'Please select a work type',
      needRights: 'Please select a rights acquisition method',
      needRightsCommit: 'Please accept the rights acquisition commitment',
      needOriginality: 'Please enter the originality statement',
      needFirstPub: 'Please enter the first publication link',
      needReuploadMedia: 'Audio, video, or document works must be re-uploaded before submission',
      needCoAuthor: 'Please add at least one co-author',
      coAuthorNameRequired: 'Co-author #{index}: please enter the name',
      coAuthorRowError: 'Co-author #{index}: {error}',
      coAuthorRemoved: 'Co-author removed',
      idCardInvalid: 'Invalid ID card number: {error}',
      creditInvalid: 'Invalid unified social credit code: {error}',
      noWorkIdForSign: 'Work ID missing; save/create the filing before signing',
      qrFail: 'Failed to generate signature QR code. Please try again',
      signGot: 'Signature retrieved',
      signSynced: 'Signature synced',
      signPending: 'Signature not found yet. Complete signing on your phone and try again',
      developing: 'Feature under development',
      saveBusy: 'Too many requests. Please wait before submitting again',
      saveFail: 'Save failed. Please try again later',
      attachOk: 'Attachment uploaded',
      uploadNoUrl: 'Upload failed: file URL missing',
      vipLoading: 'Membership dialog is loading. Please try again shortly',
      selectPayMethod: 'Please select a payment method',
      needIntlName: 'Please enter {label}',
      useWechat: 'Please use WeChat Pay',
      paySuccess: 'Payment successful'
    }
  },

  certVerify: {
    bannerAlt: 'Digital record verification banner',
    tabCertificate: 'Certificate & Report Verification',
    tabTimestamp: 'Timestamp Verification',
    international: 'International Verification',
    placeholder: 'Enter certificate or report number to verify authenticity and details',
    search: 'Search',
    invalidNumber: 'Invalid certificate number: ',
    notFound: 'No record found for this certificate number. Please check and try again.',
    toastEmpty: 'Please enter a certificate number',
    toastInvalid: 'Please enter a valid certificate or report number',
    toastEmptyCert: 'Certificate number cannot be empty',
    toastNotFilingCert: 'This is not a digital filing certificate number',
    toastNotFoundFiling: 'No filing record found for this certificate number',
    toastQueryFail: 'Failed to query filing information',
    loading: 'Verifying...',
    result: {
      header: {
        platform: 'Shenzhen Copyright Public Service Platform',
        outlet: 'Shenzhen Intellectual Property Public Service Outlet',
        title: 'Digital Record Verification'
      },
      headerEn: {
        platform: 'Shenzhen Copyright Public Service Platform',
        outlet: 'Shenzhen Intellectual Property Public Service Outlet',
        title: 'Digital Record Verification'
      },
      ipgoAlt: 'IPGO Digital Copyright Assistant',
      validAlt: 'Valid',
      revoked: 'Revoked after verification',
      certNo: 'Certificate No.',
      certNoColon: 'Certificate No.: ',
      filingInfo: 'Filing Information',
      label: {
        filingType: 'Filing Type: ',
        workName: 'Work Title: ',
        filingUnit: 'Filing Unit: ',
        filingChannel: 'Filing Channel: ',
        workType: 'Work Type: ',
        applicant: 'Applicant: ',
        filingTime: 'Filing Time: ',
        sha256: 'SHA256: ',
        fingerprint: 'Digital Fingerprint: ',
        identity: 'Verified Identity: ',
        idType: 'ID Type: ',
        idNo: 'ID Number: '
      },
      filingType: {
        original: 'Original Work Filing',
        product: 'Product Design Evidence'
      },
      filingUnitValue: 'Shenzhen Copyright Association',
      none: 'None',
      utcNote: '(UTC+8 National Time Service Center Standard Time)',
      utcNoteLegacy: '(China National Time Service Center Standard Time)',
      idTypePersonal: 'ID Card',
      idTypeEnterprise: 'Business License',
      section: {
        workDetail: 'Work Details',
        workDesc: 'Work Description',
        firstPubLink: 'First Publication Link'
      },
      previewTag: 'Preview',
      mainImage: 'Main Image',
      mainFile: 'Main File',
      zoomImage: 'Zoom image',
      downloadPage: 'Download page as image',
      downloadImage: 'Download image',
      audio: 'Audio',
      video: 'Video',
      document: 'Document',
      thumbnail: 'Thumbnail',
      workTitle: 'Work “{name}”',
      author: 'Author: ',
      docPreviewFail: 'Failed to load document preview',
      openInNewWindow: 'Open in new window',
      openInNewWindowBtn: 'Open in new window',
      docPreview: 'Document preview',
      openDocInNewWindow: 'Click to open document in a new window',
      docPreviewFailClick: 'Preview failed. Click to open in a new window',
      noDescription: 'No description',
      snapshot: 'Snapshot',
      snapshotAlt: 'Snapshot',
      noSnapshot: 'No snapshot',
      linkDomain: 'Link Domain',
      generatingImage: 'Generating image…',
      close: 'Close',
      unnamed: 'Untitled',
      footer: {
        digital: 'Digital Filing: ',
        registration: 'Work Registration: ',
        membership: 'Membership: ',
        address: 'Address: ',
        software: 'Software Registration: ',
        evidence: 'Evidence Solidification: ',
        email: 'Email: ',
        qrOfficial: 'Shenzhen Copyright Association',
        qrOfficialSub: 'WeChat Official Account',
        qrAlt: 'Official account QR code'
      },
      toast: {
        noFileUrl: 'File URL not found',
        noImageUrl: 'Image URL not found',
        noPageContent: 'Unable to capture page content',
        imageDownloaded: 'Image downloaded',
        generateFail: 'Failed to generate image. Please try again',
        generateCertFail: 'Failed to generate certificate image. Please try again',
        noLink: 'No link available',
        copied: 'Copied'
      },
      legacy: {
        invalidTitle: 'Invalid certificate number',
        missingInfo: 'Certificate information not found',
        verifyFail: 'Verification failed. Please try again later',
        downloadName: 'Legacy Digital Record Verification',
        thumbFront: 'Auxiliary',
        thumbSide: 'Side View',
        thumbBack: 'Back View',
        thumbFive: 'Image 5',
        thumbSix: 'Image 6'
      }
    }
  },

  timestampVerify: {
    title: 'Trusted Timestamp Verification',
    subtitle: 'Upload the file and trusted timestamp certificate to verify integrity and authenticity.',
    fileBlockTitle: 'File to Verify',
    fileUploadHint: 'Click or drag the file here. Ensure it has not been processed or re-compressed.',
    fileUploadHint2: 'Supports images, Word, PDF, audio and video. Max size',
    fileUploadHint3: '25MB per file.',
    certBlockTitle: 'Trusted Timestamp Certificate',
    certUploadHint: 'Click or drag the Trusted Timestamp Certificate here (*.tsa)',
    certUploadHint2: 'or certificate PDF (*.pdf). Max size 25MB.',
    verify: 'Verify',
    passTitle: 'This electronic document has passed verification',
    passLine1: 'This proves that the electronic document',
    passLine2: 'has existed since the timestamp was applied and remains intact and unmodified',
    verifiedFiles: 'Verified files:',
    fileName: 'File name: ',
    certName: 'Trusted timestamp certificate: ',
    certValid: '(Certificate valid)',
    authInfo: 'Trusted Timestamp Authentication Info',
    source: 'Source: ',
    applicant: 'Applicant: ',
    fileNameLabel: 'File name: ',
    timeInfo: 'Time: ',
    hashCode: 'Timestamp hash (digital fingerprint): ',
    fingerprintTip: 'The encoded fingerprint is an internal unique identifier designed by United Trust for file identification.',
    encodedFingerprint: 'Encoded fingerprint: ',
    moreInCert: 'See the trusted timestamp certificate for more details',
    copyInfo: 'Copy Verification Info',
    continueVerify: 'Continue Verification',
    failTitle: 'This electronic document failed trusted timestamp verification',
    back: 'Back',
    copySuccess: 'Copied',
    copyFail: 'Copy failed',
    sizeLimit: 'File size cannot exceed 25MB!',
    uploadNoUrl: 'Upload succeeded but no file URL was returned',
    defaultFileName: 'File',
    uploadSuccess: 'Upload successful',
    uploadFail: 'Upload failed',
    uploadFailRetry: 'Upload failed, please retry',
    needFile: 'Please upload the file to verify',
    needCert: 'Please upload the trusted timestamp certificate',
    uploading: 'File is uploading, please verify later',
    verifySubmitted: 'Verification request submitted'
  },

  route: {
    portalHome: 'Home',
    forYou: 'For You',
    education: 'Education',
    knowledgeClass: 'Courses',
    practice: 'Practice',
    practiceDetail: 'Practice Detail',
    onlineExam: 'Online Exam',
    examRecordDetail: 'Exam Record Detail',
    examRecords: 'Exam Records',
    wrongPractice: 'Wrong Answers',
    examDetail: 'Exam Detail',
    myCertificates: 'My Certificates',
    courseDetail: 'Course Detail',
    courseLearn: 'Course Learning',
    originalWorkFiling: 'Original Work Filing',
    productLaunchFiling: 'Product Launch Evidence',
    ipQuery: 'IP Query',
    ipManagement: 'IP Management',
    evidenceCollection: 'Self Evidence',
    copyrightSocialOrg: 'Copyright Social Orgs',
    homePlaceholder: 'Placeholder',
    workCopyrightRegistration: 'Work Copyright Reg.',
    softwareCopyrightRegistration: 'Software Copyright Reg.',
    tsaEvidence: 'TSA Evidence',
    ipDisputeMediation: 'IP Dispute Mediation',
    copyrightAppraisal: 'Copyright Appraisal',
    copyrightCompliance: 'Compliance Guidance',
    copyrightTraining: 'Training Cooperation',
    infringementAppeal: 'Infringement Appeal',
    findIp: 'Find IP',
    findBrand: 'Find Brand',
    findSupply: 'Find Supply Chain',
    ipDetail: 'IP Detail',
    brandDetail: 'Brand Detail',
    supplyDetail: 'Supply Chain Detail',
    derivativeCaseDetail: 'Derivative Case Detail',
    professionalNews: 'Professional News',
    professionalNewsDetail: 'Professional News Detail',
    licensingNews: 'Licensing News',
    licensingNewsDetail: 'Licensing News Detail',
    frontierReport: 'Frontier Reports',
    deepAnalysis: 'In-depth Analysis',
    deepAnalysisDetail: 'In-depth Analysis Detail',
    industryEvents: 'Events',
    activityDetail: 'Activity Detail',
    regulations: 'Policies',
    regulationsDetail: 'Policy Detail',
    industryDistribution: 'Industry Map',
    copyrightPreExamination: 'Copyright Pre-review',
    copyrightRiskMonitoring: 'Risk Monitoring',
    contractTemplates: 'Contract Templates',
    freeConsultation: 'Free Consultation',
    timestampVerify: 'Timestamp Verification',
    excellentLawFirms: 'Featured Law Firms',
    excellentConsulting: 'Featured Consultancies',
    maintenance: 'Under Maintenance',
    userCenter: 'User Center',
    personalAuth: 'Personal Verification',
    enterpriseAuth: 'Enterprise Verification',
    enterpriseAdmin: 'Enterprise Admin',
    resetPassword: 'Reset Password',
    myAuthorization: 'My Authorizations',
    freeRights: 'Free Benefits',
    platformVip: 'Platform VIP',
    businessMember: 'Business Membership',
    inviteUser: 'Invite Users',
    educationRights: 'Education Benefits',
    copyrightPublicAction: 'Public Action',
    myRecord: 'My Records',
    myOrder: 'My Orders',
    myInvoice: 'My Invoices',
    myConsultation: 'My Consultations',
    myActivity: 'My Activities',
    myFavorite: 'My Favorites',
    messageCenter: 'Message Center',
    contentDisplay: 'Content',
    columnContentDetail: 'Column Detail',
    operationGuide: 'User Guide',
    recommendDetail: 'Recommendation Detail',
    contentDetail: 'Content Detail',
    registerAgreement: 'Registration Agreement',
    privacyPolicy: 'Privacy Policy',
    enterpriseWorkbench: 'Enterprise Workbench',
    eSignature: 'E-Signature',
    certificateReportVerification: 'Certificate & Report Verification',
    ipgoInternationalVerification: 'IPGO International Verification',
    ipgoDigitalRecordVerification: 'IPGO Digital Record Verification',
    digitalFilingVerification: 'Digital Filing Verification',
    evidenceReportDetail: 'Evidence Report Detail',
    monitoringReportDetail: 'Monitoring Report Detail'
  }
}
